// Components==============
import Button from 'components/UI/Button/Button';
import Dropdown from 'components/UI/Dropdown/Dropdown';
import Modal from 'components/UI/Modal/Modal';
import { useRedux } from 'hooks/useRedux';
import { useTranslate } from 'hooks/useTranslate';
import { TrainingDetailsContext } from 'pages/Workspace/TrainingDetails/TrainingDetails';
import React, { useContext, useState } from 'react';
import { useHistory } from 'react-router';
import './SettingsModal.module.scss';
// =========================

export default function SettingsModal({
  setModalIsOpen,
}: {
  setModalIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  const organisation =
    useRedux((state) => state.authentication?.user.organisation.name) || '';

  const { training, handlePublish } = useContext(TrainingDetailsContext);
  const translate = useTranslate();
  const history = useHistory();

  const options: { value: 'private' | 'org' | 'public'; label: string }[] = [
    { value: 'private', label: translate('general.terms.private') as string },
    { value: 'org', label: organisation },
    {
      value: 'public',
      label: translate('course.visibility.public.label') as string,
    },
  ];

  const initialOption = !training?.is_published
    ? (translate('course.publish-settings.select-library') as string)
    : options.find((v) => v?.value === training?.visibility)?.label || '';

  const [selected, setSelected] = useState(initialOption);

  function handleClick() {
    const visibility = options.find((o) => o.label === selected)?.value;

    if (visibility) {
      handlePublish(visibility);
      setModalIsOpen(false);
    }
  }

  return (
    <Modal setModalIsOpen={setModalIsOpen} size="medium">
      <div styleName="wrapper">
        <img src="/images/world.svg" alt="world" />
        <h2>
          {training?.is_published && training?.visibility !== 'private'
            ? translate('course.publish-settings.title')
            : translate('course.publish-popup.title')}
        </h2>
        <p>
          {translate('course.publish-popup.text01')}
          <br />
          {translate('course.publish-popup.text01.1')}
          <br />
          {translate('general.terms.more-info')}{' '}
          <a
            onClick={() => {
              history.push('/bibliotheek/groowtorials');
            }}
          >
            {translate('project.publication-popups.view-sharecode-groowtorial')}
          </a>
        </p>
        <p>
          <b>{translate('course.publish-popup.subtitle01')}</b>
          <br />
          {translate('course.publish-popup.text02')}
          <br />
          {translate('course.publish-popup.text03')}
          <br />
          {translate('course.publish-popup.text04')}
          <br />
          {translate('course.publish-popup.text05')}
          <br />
          {translate('course.publish-popup.text06')}
          <br />
          <br />
        </p>
        <p>
          <b>{translate('general.terms.library')}</b>
        </p>
        <div styleName="dropdown">
          <Dropdown
            selectedItem={selected}
            setSelectedItem={setSelected}
            initialOptions={options.map((o) => o.label)}
            initialText={initialOption}
          />
        </div>
        <div styleName="button-wrapper">
          <Button color="grey" onClick={() => setModalIsOpen(false)}>
            {translate('general.terms.cancel')}
          </Button>
          <Button onClick={handleClick} inactive={initialOption === selected}>
            {training?.visibility !== 'private' &&
            selected === translate('general.terms.private')
              ? translate('general.terms.revoke-publication')
              : training?.is_published && training?.visibility === 'private'
              ? translate('general.terms.publish')
              : training?.is_published
              ? translate('general.terms.edit')
              : translate('general.terms.publish')}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
